import React from "react";

const CustomRadioButton = (props = {}) => {
  const {
    name = "",
    id = "",
    radioValue = "",
    value = "",
    labelText,
    defaultChecked = false,
    disable = false,
    radioOnchange = () => {},
    checked = false
  } = props || {};

  const radioInputObj = {
    type: "radio",
    name: name,
    id: id,
    value: radioValue || value,
    onChange: e => {
      e.stopPropagation();
      !disable && radioOnchange(e, id);
    },
    className: "radioBtn",
    disabled: disable,
    checked: checked
  };

  return (
    <div className="radioBtnCont">
      <div className="radioButtonCont">
        <input {...radioInputObj} />
        <span className="contentClass" />
        {labelText !== "" && (labelText || value) && (
          <label htmlFor={id}>{labelText || value}</label>
        )}
      </div>
    </div>
  );
};

export default CustomRadioButton;
